import { Page, DataTable } from "@shopify/polaris";
import usePaymentData from "../../../../hook/usePaymentData";
import { extractHour } from "../TotalSummary/TotalSummary";
import { CashSummaryContainer } from "./CashSummaryStyles";

export function CashSummary() {
  const { totalCash } = usePaymentData();

  const rows = (totalCash || []).map((payment) => [
    extractHour(payment.createdAt),
    `R$${(payment.amountCents / 100).toFixed(2)}`,
    payment.wasConciliation ? "Sim" : "Não",
    payment.orderName || "-",
  ]);

  let totalAmountCents = 0;

  for (const payment of totalCash || []) {
    const amountCents = parseInt(payment.amountCents, 10) || 0;
    totalAmountCents += amountCents;
  }

  const totalCashFormatted = `R$${(totalAmountCents / 100).toFixed(2)}`;

  return (
    <CashSummaryContainer>
      <Page title="Dinheiro">
        <DataTable
          showTotalsInFooter
          hideScrollIndicator
          truncate
          fixedFirstColumns
          columnContentTypes={["text", "numeric", "numeric", "text"]}
          headings={["Hora", "Valor", "Avulso", "Pedido"]}
          rows={rows}
          totals={["", totalCashFormatted, "", ""]}
          totalsName={{
            singular: "Total",
          }}
        />
      </Page>
    </CashSummaryContainer>
  );
}
